import React from 'react';
import ServicesSection from '../components/ServicesSection';

const Services = () => {
  return (
    <div>
      <ServicesSection />
    </div>
  );
};

export default Services;